<template>
  <div class="new-project">
    <div class="container-fluid">
      <!-- Begin page -->
      <div class="wrapper">
        <div class="content-page content-subProject">
          <div class="content">
            <div class="row">
              <div class="col-12">
                <div class="page-title-box">
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
                      <li class="breadcrumb-item active">发布课题申报通知</li>
                    </ol>
                  </div>
                  <h3 class="header-title mb-3">发布课题申报通知</h3>
                </div>
                <!-- end page-title-box -->
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="card-newProject">
                      <!-- 表单 -->
                      <el-form :inline="true" :model="projectForm" :rules="projectFormRules" ref="projectForm" label-width="120px" class="demo-projectForm">
                        <el-row>
                          <el-form-item label="通知标题" prop="projectName">
                            <el-input style="width: 500px;" v-model="projectForm.projectName"></el-input>
                          </el-form-item>
                        </el-row>
                        <el-row>
                          <el-form-item label="课题级别" prop="projectLevelId">
                            <el-select v-model="projectForm.projectLevelId" :disabled="isBanEditTopicLevelCategory" placeholder="请选择" @change="topicLevelChange">
                              <el-option v-for="item in options" :disabled="!item.children" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-row>
                        <el-row>
                          <el-form-item label="课题类别" prop="projectTypeName">
                            <el-checkbox-group v-model="projectForm.projectTypeName">
                              <el-checkbox :label="item.name" :disabled="isBanEditTopicLevelCategory" v-for="(item, index) in topicTypeList" :key="item.id">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </el-row>
                        <el-form-item label="核心成员限制" prop="memberNumberLimit">
                          <el-input type="number" v-model="projectForm.memberNumberLimit">
                            <template slot="append">人</template>
                          </el-input>
                        </el-form-item>
                        <el-form-item label="第二负责人" prop="twoEmceeState">
                          <el-radio-group v-model="projectForm.twoEmceeState">
                            <el-radio :label="1">允许</el-radio>
                            <el-radio :label="0">不允许</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item label="匿名评审活页" prop="anonymousReviewState">
                          <el-radio-group v-model="projectForm.anonymousReviewState">
                            <el-radio :label="1">上传</el-radio>
                            <el-radio :label="0">不上传</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <div class="form-item-title">初审通过名额：</div>
                        <el-form-item label="直属学校" prop="trialByNumber">
                          <el-input v-model="projectForm.trialByNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="item.regionName" v-for="(item,index) in multipleUnitsArea" :key="'passNum'+index">
                          <el-input v-model="item.passNum" style="width: 50px;"></el-input>
                        </el-form-item>
                        <el-row>
                          <el-form-item label="申报说明" prop="note">
                            <el-col :span="24">
                              <TinymceEditor @input="e => changeData('note', e)" :value="projectForm.note" :baseUrl="uploadUrl"></TinymceEditor>
                            </el-col>
                          </el-form-item>
                        </el-row>
                        <template v-if="(projectForm.projectNumber instanceof Array)">
                          <div class="form-item-title" v-if="projectForm.projectNumber.length">立项编号前缀：</div>
                          <el-form-item prop="projectNumber" :label="item.label" v-for="(item, index) in projectForm.projectNumber" :key="index">
                            <el-input v-model="item.value"></el-input>
                          </el-form-item>
                        </template>
                        <el-row>
                          <el-form-item label="申请截止日期" prop="declareEndTime">
                            <el-date-picker default-time="23:59:59" v-model="projectForm.declareEndTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                          </el-form-item>
                        </el-row>
                        <el-row>
                          <el-form-item label="初审截止日期" prop="trialEndTime">
                            <el-date-picker default-time="23:59:59" v-model="projectForm.trialEndTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                          </el-form-item>
                        </el-row>
                        <el-form-item label="附件" prop="attachment" class="upload">
                          <!-- projectForm.attachment -->
                          <UploadFileMore :filelist="projectForm.attachment"></UploadFileMore>
                          <!-- <el-upload
							class="upload-demo"
							:action="uploadUrl+'/upload/uploadToLocal'"
							multiple
							:limit="10"
							:before-remove="beforeRemove"
							:on-exceed="handleExceed"
							:on-success="uploadSuccess"
							:file-list="fileList"
						>
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload> -->
                        </el-form-item>
                        <el-row>
                          <el-form-item label="立项通知标题" prop="projectTitle">
                            <el-input v-model="projectForm.projectTitle"></el-input>
                          </el-form-item>
                        </el-row>
                      </el-form>
                      <el-row style="text-align: center;">
                        <el-button type="primary" @click="addNewProject">确定</el-button>
                        <el-button type="primary" @click="goBack">返回</el-button>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end wrapper-->
    </div>
  </div>
</template>

<script>
import TinymceEditor from '@/components/TinymceEditor.vue';
import UploadFileMore from '@/components/upLoad/UploadFileMore.vue'
import { uploadFile, getHasUnitsArea, addOrEditProject } from '@/api/after/projectApplication.js';
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
export default {
  components: {
    TinymceEditor,
    UploadFileMore
  },
  name: 'newProject',
  watch: {
    'projectForm.projectTypeName': {
      handler(newVal) {
        if (newVal instanceof Array) {
          console.log('修改课题类别', newVal);
          let arr = []
          newVal.forEach(item => {
            let obj = this.projectForm.projectNumber.find(item1 => {
              return item1.label == item
            })
            if (obj) {
              arr.push(obj)
            } else {
              arr.push({
                label: item,
                value: ''
              })
            }
          });
          this.projectForm.projectNumber = arr
        }
      }
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入成员限制数！'));
      } else if (value > 20) {
        callback(new Error('成员数量不能大于20！'));
      } else if (value < 1) {
        callback(new Error('成员数量不能小于1！'));
      } else {
        callback();
      }
    };
    var validateProjectNumber = (rule, value, callback) => {
      console.log(value);
      value.find(item => {
        if (item.value == '') {
          callback(new Error('请输入立项编号前缀！'));
        } else {
          callback();
        }
      })
    };
    return {
      list: [],
      projectForm: {
        projectName: '',
        projectLevelId: '',
        projectLevelName: '',
        projectTypeId: [],
        projectTypeName: [],
        memberNumberLimit: '',
        trialByNumber: '',//	单区域初审通过名额
        note: '',
        projectNumber: [],//立项编号
        declareEndTime: '',//	申报截止日期
        trialEndTime: '',//	初审结束日期
        attachment: [],//附件
        projectTitle: '',//	立项通知标题
        number: '',//区域设置初审数量和区域对应用逗号隔开
        regionId: '',//区域id多个区域用逗号隔开
        twoEmceeState: 0,//第二负责人
        anonymousReviewState: 1,//匿名评审活页
      },
      multipleUnitsArea: [],//有多个单位的区域
      projectFormRules: {
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }, { max: 30, message: '长度最大20个字符', trigger: 'blur' }],
        memberNumberLimit: [{ required: true, validator: validatePass, trigger: 'blur' }],
        declareEndTime: [{ required: true, message: '请选择截止日期', trigger: 'blur' }],
        trialEndTime: [{ required: true, message: '请选择截止日期', trigger: 'blur' }],
        projectLevelId: [{ required: true, message: '请选择课题级别', trigger: 'change' }],
        projectTypeName: [{ required: true, message: '请选择课题类别（需先选择课题级别）', trigger: 'change' }],
        trialByNumber: [{ required: true, message: '请输入初审通过名额', trigger: 'blur' }],
        note: [{ required: true, message: '请输入申报说明', trigger: 'change' }],
        projectNumber: [{ required: true, validator: validateProjectNumber, trigger: 'bulr' }],
        anonymousReviewState: [{ required: true, message: '请选择是否上传匿名评审活页', trigger: 'change' }],
        twoEmceeState: [{ required: true, message: '请选择是否允许第二负责人', trigger: 'change' }],
      },
      options: [],
      topicTypeList: [
        {
          name: '请先选择课题级别',
          disabled: true
        }
      ],
      fileList: [],//上传附件
      isBanEditTopicLevelCategory: false,//是否禁止修改课题的级别类别数据
    };
  },
  async created() {
    // 获取课题级别
    await this.getPlatformInformationData();
    // 获取有多个单位的区域，便于给该区域分别设置初审通过名额
    await this.getHasUnitsArea()
    if (this.$route.query.projectData) {
      let data = JSON.parse(decodeURIComponent(this.$route.query.projectData));
      console.log('回显数据', data);
      // 判断是否禁止修改课题级别类别
      if (!data.mark) {
        this.isBanEditTopicLevelCategory = true
      }
      // 回显课题类别数据
      this.topicLevelChange(data.projectLevelId)
      if (data.projectTypeName) {
        data.projectTypeName = data.projectTypeName.split(',')
      } else {
        data.projectTypeName = []
      }
      // 回显初审通过名额数据
      if (data.number) {
        let numberArr = data.number.split(',')
        let regionIdArr = data.regionId.split(',')
        regionIdArr.forEach((item, index) => {
          this.multipleUnitsArea.forEach((item1, index1) => {
            if (item == item1.id) {
              if (numberArr[index] == 9999) {
                item1.passNum = ""
              } else {
                item1.passNum = numberArr[index]
              }
            }
          })
        })
      }
      // 立项编号前缀回显
      if (data.projectNumber) {
        let numberArr = data.projectNumber.split(',').map(item => {
          let arr = item.split('-')
          return {
            label: arr[0],
            // value:arr[1].slice(0,-3)
            value: arr[1]
          }
        })
        console.log('处理数据', numberArr);
        data.projectNumber = numberArr
      }
      //处理附件回显
      if (data.attachment) {
        console.log('处理数据', data);
        let arr = data.attachment.split(',')
        let nameArr = data.annexName.split(',')
        data.attachment = arr.map((item) => {
          return { id: item }
        })
        nameArr.forEach((item, index) => {
          data.attachment[index].name = item
        })
      } else {
        data.attachment = []
      }
      this.projectForm = JSON.parse(JSON.stringify(data))
    }

  },
  methods: {
    // 添加新项目
    addNewProject() {
      this.$refs.projectForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          // 区域下没有填写初审通过名额的通过名额改变为9999
          this.multipleUnitsArea.forEach((item, index) => {
            if (item.passNum == '') {
              item.passNum = 9999
            }
          })

          console.log('处理前', this.projectForm);
          let newObj = JSON.parse(JSON.stringify(this.projectForm))
          // 将课题类型处理为字符串
          let topicTypeIdList = [];
          newObj.projectTypeName.forEach(item => {
            let topicTypeObj = this.topicTypeList.find(item1 => {
              return item1.name === item;
            });
            topicTypeIdList.push(topicTypeObj.id);
          });
          newObj.projectTypeId = topicTypeIdList.join(',');
          newObj.projectTypeName = newObj.projectTypeName.join(',');
          // 处理立项编号数据
          let projectNumberArr = [];
          newObj.projectNumber.forEach(item => {
            // projectNumberArr.push(item.label +'-'+ item.value + Math.floor(Math.random() * 1000));
            projectNumberArr.push(item.label + '-' + item.value);
          });
          newObj.projectNumber = projectNumberArr.join(',');
          // 处理上传的图片
          let attachmentArr = []
          newObj.attachment.forEach(item => {
            attachmentArr.push(item.id)
          })
          newObj.attachment = attachmentArr.join(',')
          // 处理初审通过名额
          let areaIdArr = []
          let passNumArr = []
          this.multipleUnitsArea.forEach(item => {
            areaIdArr.push(item.id)
            passNumArr.push(item.passNum)
          })
          newObj.regionId = areaIdArr.join(',')
          newObj.number = passNumArr.join(',')
          // 处理时间

          newObj.trialEndTime = newObj.trialEndTime
          newObj.declareEndTime = newObj.declareEndTime

          console.log('处理后', newObj);

          this.$refs.projectForm.validate(async valid => {
            if (valid) {
              const res = await addOrEditProject(newObj)
              if (res.code == 200) {
                if (this.$route.query.projectData) {
                  this.$message.success('修改成功')
                } else {
                  this.$message.success('新增成功')
                }
                this.$router.go(-1)
              } else {
                this.$message.error(res.data)
              }
            } else {
              this.$message.error('请正确填写表单')
            }
          })
        }
      })
    },

    // 获取课题级别类别目录
    async getPlatformInformationData() {
      const res = await getPlatformInformationData(1);
      console.log('课题级别类别', res);
      if (res.code == 200) {
        this.options = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    // 添加或者更新项目
    // async updateEduProject() {
    // 	const res = await updateEduProject(this.projectForm);
    // 	if (res.code == 200) {
    // 		console.log('添加项目', res);
    // 	} else {
    // 		this.$message.error(res.msg);
    // 	}
    // },
    // 获取有多个单位的区域
    async getHasUnitsArea() {
      const res = await getHasUnitsArea()
      if (res.code == 200) {
        console.log('有多个单位的区域的列表', res);
        res.data.forEach(item => {
          item.passNum = ''
        })
        this.multipleUnitsArea = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    // 课题级别选择
    topicLevelChange(val) {
      console.log(val);
      this.projectForm.projectNumber = []//每次选择课题级别时，初始化立项编号数据
      this.projectForm.projectTypeName = []//每次选择课题级别时，初始化可以课题类别数据
      let topicTypeObj = this.options.find(item => {
        return item.id == val;
      });
      console.log('课题级别', topicTypeObj);
      //获取所选课题级别名称
      this.projectForm.projectLevelName = topicTypeObj.name;
      this.topicTypeList = topicTypeObj.children;
    },
    // 上传文件成功后
    uploadSuccess(res, file, fileList) {
      console.log('上传成功', res, fileList);
      this.projectForm.attachment.push({
        imgId: res.data[0],
        uid: file.uid
      });
      console.log(this.projectForm.attachment);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      this.$confirm('删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let removeFileIndex = this.projectForm.attachment.findIndex(item => {
            return item.uid == file.uid;
          });
          this.projectForm.attachment.splice(removeFileIndex, 1);
          console.log(this.projectForm.attachment);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    goBack() {
      this.$router.go(-1)
    },
    changeData(name, data) {
      this.projectForm[name] = data;
    },
  }
};
</script>

<style scoped lang="scss">
.upload {
  width: 80%;
  & ::v-deep .el-form-item__content {
    width: 80%;
  }
}
.form-item-title {
  margin: 0 0 10px 20px;
  font-size: 14px;
  color: #606266;
  font-weight: bold;
}
</style>
